import { IconWrapper } from '../runtime';
export default IconWrapper('ap_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#9152FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#7C3DEA"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#A470FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#9152FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.03125 4.78125H14.3438V6.65625H4.03125V4.78125Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.03125 8.25H14.3438V10.125H4.03125V8.25Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.4062 11.7188H4.03125V13.5938H10.4062V11.7188Z",
      "fill": "white"
    }
  })]);
});